export default function getCSSSelector(className) {
  var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '.' + className + pseudo;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateCSSSelector.js
// module id = 699
// module chunks = 0